import styled from 'styled-components';

export const CoordsP = styled.p`
display: none;
`;

export const NavHeader = styled.h1`
font-size: 48px;
color: #000;
text-align: center;

@media screen and (max-width: 768px){
    font-size: 36px;
}

@media screen and (max-width: 480px){
    font-size: 28px;
}
`;

export const NavDesc = styled.p`
font-size: 24px;
color: #101110;
font-weight: bold;
text-align: center;

@media screen and (max-width: 768px){
    font-size: 18px;
}

@media screen and (max-width: 480px){
    font-size: 14px;
}
`;

export const NavDesc2 = styled.p`
font-size: 18px;
color: #101110;
margin-top: 10px;
text-align: center;

@media screen and (max-width: 768px){
    font-size: 14px;
}

@media screen and (max-width: 480px){
    font-size: 11px;
}
`;
